import { useLayoutEffect } from 'react';

import { useGetMe } from '@/api/generated/users.ts';
import { useApplicationContext } from '@/contexts/ApplicationContext.tsx';
import { readPreview } from '@/experiments/colorsPreview.ts';

import { applyAppearance, readStoredAppearance, removeAppearance } from './appearance.ts';
import { LAYOUTS } from './themes.ts';

// The signed-in user's appearance (plan task 120) on the app while it's open, in the light or dark theme it shows,
// and how the app's frame is arranged for it. Until the account is loaded, what this browser last showed.
const useAppearance = () => {
    const me = useGetMe();
    const { isDarkMode } = useApplicationContext();
    const appearance = me.data ? me.data.appearance : readStoredAppearance();
    // A new object on every render while it's read from storage, so the effect compares its content.
    const appearanceKey = JSON.stringify(appearance);

    useLayoutEffect(() => {
        // An option of experiments/colors tried on the whole app stays over it until it's reset there.
        if (readPreview()) return;
        applyAppearance(JSON.parse(appearanceKey), isDarkMode);
    }, [appearanceKey, isDarkMode]);

    useLayoutEffect(() => removeAppearance, []);

    return { shell: appearance ? LAYOUTS[appearance.layout]?.shell : undefined };
};

export default useAppearance;
